import React from "react";
import {
  Button,
  Checkbox,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Typography,
} from "@material-tailwind/react";

const TERMS_SECTIONS = [
  {
    title: "مقدمه – پذیرش قوانین",
    content: [
      {
        type: "paragraph",
        text: "این سند، **قوانین همکاری مشاوران با پلتفرم مباشر** است که بر مبنای ماده ۱۰ قانون مدنی ایران تنظیم شده است.",
      },
      {
        type: "paragraph",
        text: "هر کاربر حقیقی یا حقوقی که در بخش مشاوران پلتفرم به آدرس WWW.Mymobasher.com یا پنل cp.mymobasher.com ثبت‌نام می‌کند و گزینه **«پذیرش قوانین همکاری»** را تأیید (تیک) می‌زند، کلیه مفاد زیر را مطالعه کرده، درک نموده و ملتزم به اجرای آن می‌شود.",
      },
    ],
  },
  {
    title: "بند ۱ – تعریف پلتفرم و طرفین",
    content: [
      {
        type: "paragraph",
        text: "**مباشر:** شرکت فرصت سازان ایده همساز به شناسه ملی ۱۴۰۰۷۶۴۵۰۶۰، نشانی: تهران، بزرگراه جناح، کوچه احسانگر، پلاک ۱/۱، طبقه دوم – که بستر فناوری اطلاعات را برای اتصال مشاوران به کاربران نهایی (مشتریان) فراهم می‌کند.",
      },
      {
        type: "paragraph",
        text: "**مشاور:** شخص حقیقی یا حقوقی که اطلاعات زیر را در پنل کاربری خود تکمیل می‌کند (ورود این اطلاعات برای فعالیت الزامی است):",
      },
      {
        type: "list",
        items: [
          "نام مشاور ({advisorName})",
          "کد ملی / شناسه ملی ({nationalCode})",
          "نشانی کامل ({address})",
          "شماره تماس ({phone})",
          "پست الکترونیک ({email})",
        ],
      },
    ],
  },
  {
    title: "بند ۲ – موضوع و ماهیت همکاری",
    content: [
      {type: "paragraph", text: "مشاور خدمات مشاوره، کارشناسی و خدمات تخصصی (حضوری یا غیرحضوری) را به مشتریان معرفی‌شده از طریق پلتفرم ارائه می‌دهد."},
      {type: "paragraph", text: "این همکاری **رابطه استخدامی، کارفرمایی، شراکت یا نمایندگی تام‌الاختیار** ایجاد نمی‌کند."},
      {type: "paragraph", text: "مشاور **مشمول قوانین کار و تأمین اجتماعی** به عنوان کارمند مباشر نیست."},
      {type: "paragraph", text: "مسئولیت مالیات و بیمه همکاری‌های مستقل، مستقیماً بر عهده مشاور است."},
    ],
  },
  {
    title: "بند ۳ – تعهدات و قوانین رفتاری مشاور در سایت",
    content: [
      {
        type: "ordered-list",
        items: [
          "**زمان‌بندی و تحویل:** مشاور موظف است پس از دریافت درخواست، زمان تقریبی تکمیل خدمت را در سامانه ثبت کند. تأخیر بدون دلیل موجه و تأیید پشتیبانی، موجب کسر جریمه یا عدم پرداخت آن خدمت می‌شود.",
          "**رفتار حرفه‌ای:** مشاور باید با صدای رسا، لحن مناسب، ادب کامل و بدون قطع زودهنگام جلسه پاسخگو باشد. رفتار غیرحرفه‌ای باعث کاهش امتیاز یا لغو دسترسی می‌شود.",
          "**بستر رسمی:** کلیه ارتباطات، تبادل اطلاعات و دریافت وجه فقط از طریق پلتفرم مباشر مجاز است. ارتباط مستقیم با مشتری خارج از پلتفرم (شماره تلفن، ایمیل شخصی، پیام‌رسان خارجی) **نقض فاحش** محسوب شده و منجر به مسدودسازی دائمی حساب می‌شود.",
          "**ممنوعیت واگذاری:** مشاور حق ندارد خدمت را به شخص ثالث واگذار کند. در صورت نقض، مباشر از پرداخت حق‌العمل آن خدمت معاف است.",
          "**تأیید صلاحیت:** مشاور موظف است مدارک شناسایی، تحصیلی و مجوزهای لازم را پیش از فعالیت در پلتفرم بارگذاری کند. در صورت کشف بعدی عدم صلاحیت، مسئولیت کامل با مشاور است.",
          "**گزارش‌دهی:** پس از هر خدمت، مشاور باید نتیجه و مستندات را در پنل کاربری ثبت کند.",
          "**عدم همکاری مشتری:** اگر مشتری در رزرو یا ارائه مدارک تخلف کند، مسئولیت از مشاور و مباشر ساقط می‌شود و مشاور حق دریافت دستمزد متناسب از سپرده مشتری را دارد.",
          "**پذیرش تغییرات الکترونیکی:** تمام تغییرات قوانین، نرخ‌ها و رویه‌ها از طریق پلتفرم ابلاغ می‌شود و تأیید (تیک) مشاور به منزله قبول است. هیچ ادعای انکار قرارداد الکترونیکی پذیرفته نیست.",
          "**بیماری یا عدم دسترسی:** مشاور موظف است فوراً از طریق پنل، عدم امکان پذیرش مشتری را با ذکر مدت و دلیل اعلام کند.",
          "**عدم رقابت به مدت ۵ سال:** مشاور حتی پس از قطع همکاری، حق ارتباط مستقیم با مشتریان معرفی‌شده از طریق پلتفرم را به مدت ۵ سال ندارد. تخلف موجب جبران خسارت است.",
        ],
      },
    ],
  },
  {
    title: "بند ۴ – قوانین مالی و تسویه حساب",
    content: [
      {
        type: "table",
        headers: ["نوع خدمت", "درصد مشاور", "درصد مباشر"],
        rows: [
          ["خدمات مشاوره (تلفنی/آنلاین/حضوری)", "۷۰٪", "۳۰٪"],
          ["خدمات اجرایی (ثبتی، مالی، مالیاتی، حقوقی، پروژه‌ای)", "۶۰٪", "۴۰٪"],
        ],
      },
      {type: "paragraph", text: "در صورت اختلاف در نوع خدمت، **تشخیص نهایی با مباشر** است."},
      {type: "paragraph", text: "تغییر درصدها فقط با توافق کتبی و تأیید مدیر پشتیبانی امکان‌پذیر است."},
      {type: "paragraph", text: "تسویه حساب مشاوران حداکثر **۳۰ روز کاری** پس از تأیید نهایی خدمت توسط مشتری انجام می‌شود."},
      {type: "paragraph", text: "مشاور باید درخواست برداشت را ثبت کند؛ واریز به حساب بانکی ثبت‌شده در پنل انجام می‌شود."},
    ],
  },
  {
    title: "بند ۵ – مسئولیت پلتفرم (مباشر)",
    content: [
      {type: "paragraph", text: "مباشر فقط **نقش واسطه فنی** دارد و مسئولیتی در قبال محتوای مشاوره یا صحت اطلاعات ارائه‌شده توسط مشاور ندارد."},
      {type: "paragraph", text: "در اختلاف بین مشتری و مشاور توسط مدیرعامل وقت پس از بررسی مستندات، الزام‌آور است."},
      {type: "paragraph", text: "مباشر عملکرد مشاور را ضمانت نمی‌کند."},
      {type: "paragraph", text: "مسئولیت حفظ رمز عبور و امنیت حساب کاربری **به عهده مشاور** است. تا زمان اطلاع به شرکت، کلیه فعالیت‌های حساب بر عهده مشاور می‌باشد."},
    ],
  },
  {
    title: "بند ۶ – محرمانگی و مالکیت معنوی",
    content: [
      {type: "paragraph", text: "مشاور متعهد است کلیه اطلاعات مشتریان، لیست‌ها، قیمت‌گذاری و اطلاعات تجاری مباشر را **محرمانه** نگه دارد. افشا موجب جبران خسارت است. این تعهد تا ۵ سال پس از قطع همکاری ادامه دارد."},
      {type: "paragraph", text: "خروجی مشاوره‌ها متعلق به **مشتری نهایی** است. مشاور هیچ ادعای مالکیت معنوی ندارد."},
      {type: "paragraph", text: "استفاده از نام، لوگو یا برند مباشر در فعالیت‌های خارجی، بدون مجوز کتبی، تخلف محسوب می‌شود."},
    ],
  },
  {
    title: "بند ۷ – صلاحیت مشاور",
    content: [
      {type: "paragraph", text: "مشاور با پذیرش این قوانین اعلام می‌دارد:"},
      {
        type: "list",
        items: [
          "صلاحیت علمی و فنی لازم برای خدمات اعلامی را دارد.",
          "مدارک معتبر خود را در پلتفرم بارگذاری کرده است.",
          "هیچ ممنوعیت قانونی یا صنفی برای فعالیت ندارد.",
        ],
      },
    ],
  },
  {
    title: "بند ۸ – توقف همکاری و مسدودسازی حساب",
    content: [
      {
        type: "ordered-list",
        items: [
          "**مسدودسازی یک‌طرفه توسط مباشر:** در صورت نقض هر یک از مفاد بالا، مباشر می‌تواند بدون اخطار قبلی، حساب مشاور را **غیرفعال یا مسدود** کند.",
          "**تسویه پس از مسدودسازی:** مبالغ پرداخت‌نشده، پس از کسر خسارت احتمالی، ظرف ۳۰ روز تسویه می‌شود.",
          "**مدت اعتبار قوانین:** با رضایت پلتفرم این قوانین از تاریخ پذیرش توسط مشاور معتبر است و مادامی که از سوی هر یک از طرفین فسخ نیابد در پایان هر **سال شمسی** به صورت خودکار برای دوره ای یک ساله تمدید می شود. هر طرف با ۱۵ روز اخطار کتبی می‌تواند همکاری را پایان دهد.",
        ],
      },
    ],
  },
  {
    title: "بند ۹ – حل اختلاف",
    content: [
      {
        type: "ordered-list",
        items: [
          "ابتدا اختلاف از طریق **مرکز داوری اتحادیه های تعاونی عمرانی تهران** حل می‌شود.",
          "در صورت عدم توافق ظرف ۳۰ روز، مرجع صالح **دادگاه‌های محل استقرار قانونی مباشر** (تهران) خواهد بود.",
        ],
      },
    ],
  },
  {
    title: "بند ۱۰ – قوانین عمومی",
    content: [
      {type: "paragraph", text: "این قوانین جایگزین هر گونه توافق شفاهی قبلی است."},
      {type: "paragraph", text: "پذیرش با **تیک زدن گزینه «قوانین همکاری مشاوران را مطالعه کرده و می‌پذیرم»** در پنل کاربری، معادل امضای الکترونیکی و دارای اثر حقوقی کامل است."},
    ],
  },
];

export function AgentRequestTermsModal({
  open,
  setOpen,
  applicantInfo,
  termsAccepted,
  setTermsAccepted,
  submitting,
  onSubmit,
}) {
  const termsValues = {
    advisorName: applicantInfo[0]?.value,
    nationalCode: applicantInfo[1]?.value,
    address: applicantInfo[2]?.value,
    phone: applicantInfo[3]?.value,
    email: applicantInfo[4]?.value,
  };

  const formatTermsText = (text) => {
    return text.replace(/\{(\w+)}/g, (_, key) => termsValues[key] || "-");
  };

  const renderFormattedText = (text) => {
    const formattedText = formatTermsText(text);
    return formattedText.split(/(\*\*.*?\*\*)/g).filter(Boolean).map((part, index) => {
      if (part.startsWith("**") && part.endsWith("**")) {
        return <span key={`${part}-${index}`} className="font-bold text-black">{part.slice(2, -2)}</span>
      }
      return <React.Fragment key={`${part}-${index}`}>{part}</React.Fragment>
    });
  };

  const renderTermsContent = (content, index) => {
    if (content.type === "paragraph") {
      return (
        <Typography key={index} variant="small" className="text-[0.93rem] leading-7 text-black">
          {renderFormattedText(content.text)}
        </Typography>
      )
    }

    if (content.type === "list") {
      return (
        <ul key={index} className="flex list-disc flex-col gap-1.5 pr-8 text-[0.93rem] leading-7 text-black marker:text-black">
          {content.items.map((item) => (
            <li key={item}>{renderFormattedText(item)}</li>
          ))}
        </ul>
      )
    }

    if (content.type === "ordered-list") {
      return (
        <ol key={index} className="flex list-decimal flex-col gap-1.5 pr-8 text-[0.93rem] leading-7 text-black marker:font-semibold marker:text-black">
          {content.items.map((item) => (
            <li key={item}>{renderFormattedText(item)}</li>
          ))}
        </ol>
      )
    }

    if (content.type === "table") {
      return (
        <div key={index} className="my-2 overflow-x-auto rounded-md border border-gray-400">
          <table className="w-full min-w-[560px] border-collapse bg-white text-sm text-black">
            <thead>
              <tr>
                {content.headers.map((header) => (
                  <th key={header} className="border-b border-l border-gray-400 bg-gray-100 p-3 text-right font-bold text-black last:border-l-0">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {content.rows.map((row) => (
                <tr key={row.join("-")}>
                  {row.map((cell) => (
                    <td key={cell} className="border-b border-l border-gray-300 bg-white p-3 text-right text-black last:border-l-0">
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )
    }

    return null
  };

  return (
    <Dialog
      size="xl"
      open={open}
      handler={() => setOpen(!open)}
      className="max-h-screen overflow-hidden rounded-md bg-white text-black shadow-2xl"
      animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}
    >
      <DialogHeader className="flex flex-col items-start gap-1 border-b border-gray-300 bg-white px-5 py-4">
        <Typography variant="h5" className="w-full text-right font-bold text-black">
          قوانین همکاری مشاوران با پلتفرم مباشر
        </Typography>
        <Typography variant="small" className="w-full text-right text-black">
          لطفا متن قرارداد را با دقت مطالعه کرده و پس از پذیرش، درخواست را ارسال کنید.
        </Typography>
      </DialogHeader>
      <DialogBody className="max-h-[72vh] overflow-y-auto bg-white px-5 py-4 text-black" style={{direction: "rtl"}}>
        <div className="border-b border-gray-300 pb-4">
          <div className="mb-3 flex items-center justify-between gap-4">
            <Typography className="font-bold text-black">
              مشخصات مشاور
            </Typography>
            <Typography variant="small" className="text-black">
              تکمیل‌شده بر اساس اطلاعات ثبت‌نام
            </Typography>
          </div>
          <div className="grid grid-cols-1 overflow-hidden rounded-sm border border-gray-300 md:grid-cols-2">
            {applicantInfo.map(({label, value}) => (
              <div key={label} className="grid grid-cols-[8.5rem_1fr] border-b border-gray-300 last:border-b-0 md:[&:nth-last-child(2)]:border-b-0">
                <div className="border-l border-gray-300 bg-gray-100 px-3 py-2">
                  <Typography variant="small" className="font-semibold text-black">
                    {label}
                  </Typography>
                </div>
                <div className="bg-white px-3 py-2">
                  <Typography variant="small" className="text-black">
                    {value || "-"}
                  </Typography>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col py-4 px-2">
          {TERMS_SECTIONS.map(({title, content}) => (
            <section key={title} className="border-b border-gray-300 py-4 last:border-b-0">
              <Typography className="mb-2 border-r-4 border-black pr-3 text-base font-bold text-black">
                {title}
              </Typography>
              <div className="flex flex-col gap-1.5">
                {content.map(renderTermsContent)}
              </div>
            </section>
          ))}
        </div>

        <div className="border-t border-gray-300 pt-3">
          <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
            <Checkbox
              checked={termsAccepted}
              onChange={(event) => setTermsAccepted(event.target.checked)}
              label={
                <Typography variant="small" className="font-semibold text-black">
                  قوانین همکاری مشاوران را مطالعه کرده و می‌پذیرم
                </Typography>
              }
            />
            <Typography variant="small" className="text-black">
              پذیرش این گزینه معادل امضای الکترونیکی است.
            </Typography>
          </div>
        </div>
      </DialogBody>
      <DialogFooter className="flex flex-col-reverse gap-3 border-t border-gray-300 bg-white px-5 py-3 md:flex-row md:items-center md:justify-between">
        <Typography variant="small" className="text-black">
          پس از تایید، درخواست جهت بررسی برای پلتفرم مباشر ارسال می‌شود.
        </Typography>
        <div className="flex w-full gap-2 md:w-auto">
          <Button
            variant="outlined"
            color="gray"
            className="flex-1 border-gray-700 text-black md:flex-none"
            onClick={() => setOpen(false)}
            disabled={submitting}
          >
            انصراف
          </Button>
          <Button
            color="gray"
            className="flex-1 bg-black text-white md:flex-none"
            onClick={onSubmit}
            disabled={!termsAccepted || submitting}
          >
            {submitting ? "در حال ارسال..." : "تایید و ارسال درخواست"}
          </Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
